import {
  httpUploadFile,
} from '../axios/axiosUtils';
import {
  uploadFileURL,
} from '../axios/requests';

export interface imageProgresses {
  percentCompleted: number;
  file: File;
}

export const uploadFile = async (
  url: string, file: File, handleProgress?: (progress: {[x: string]: imageProgresses }) => void
): Promise<any> => {
  try {
    const data = new FormData();
    data.append('file', file);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
      onUploadProgress: function(progressEvent: any) {
        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        handleProgress && handleProgress({[file.name]: {percentCompleted, file }})
      }
    };

    const response = await httpUploadFile(url, data, config);
    return response;
  } catch (error) {
    console.log(error);
    throw error as Error;
  }
};

export const uploadSingleFile = async (file: File) => {
  return uploadFile(uploadFileURL, file).then((res) => res.data.downloadURL);
};


const fileFromURL = async (url: string) => {
  let blob = (await (await fetch(url,{mode:"cors"})).blob());
  let file = new File([blob], Date.now().toString(), {type: blob.type})
  return file;
}
const blobToFile = (theBlob: Blob, fileName:string): File => {
  var b: any = theBlob;
  //A Blob() is almost a File() - it's just missing the two properties below which we will add
  b.lastModifiedDate = new Date();
  b.name = fileName;
  //Cast to a File() type
  return <File>theBlob;
}
export const uploadImageFromURI = async (uri: string): Promise<string> => {
  if (!uri.startsWith('blob:') || window.location.origin !== new URL(uri).origin) {
    return uri;
  }

  let file = await fileFromURL(uri);
  if(file.type.includes('svg')) {
    const fileText = await file.text();
    const fileReplaced =  fileText.replace(/fill="(.*?)"/g, 'fill="currentColor"'); 
    const fileBlob = new Blob([fileReplaced], {type: file.type});
    file = blobToFile(fileBlob, file.name);
  }
  // console.log(fileText);
  const response = await uploadFile(uploadFileURL, file);
  return response.data.downloadURL;
}

export const uploadSingleImage = async (images: any[],handleProgress?: (progress: {[x: string]: imageProgresses}) => void ): Promise<string> => {
  const promises = [];
  const allImages: any[] = [];
  for (const media of images) {
    if (media.preview) {
      promises.push(
        uploadFile(uploadFileURL, media,handleProgress)
          .then((res: any) => {
            allImages.push(res.data.downloadURL);
          }),
      );
    } else {
      allImages.push(media.imageUrl);
    }
  }
  return Promise.all(promises)
    .then(() => {
      console.log('done');
      return (allImages.length ? allImages[0] : null);
    }).catch((error) => {
      console.log('error');
      return (allImages.length ? allImages[0] : null);
    });
};

export const uploadSingleVideo = async (videos: any[]): Promise<string> => {
  const promises = [];
  const allImages: any[] = [];
  for (const media of videos) {
    if (media.preview) {
      promises.push(
        uploadFile(uploadFileURL, media)
          .then((res: any) => {
            allImages.push(res.data.downloadURL);
          }),
      );
    } else {
      allImages.push(media.videoUrl);
    }
  }
  return Promise.all(promises)
    .then(() => {
      console.log('done');
      return (allImages.length ? allImages[0] : null);
    }).catch((error) => {
      console.log('error');
      return (allImages.length ? allImages[0] : null);
    });
};

export const uploadImages = async (images: any[], cb: (files: any[]) => void,handleProgress?: (progress: {[x: string]: imageProgresses}) => void) => {
  const length = images.length;
  if (length > 0) {
    const allImages: any[] = Array(images.length).fill(null);
    const uploadPromise = new Promise<any[]>((resolve) => {
      let processImagesCount: number = 0;
      images.forEach(async (image: any, index: number) => {
        try {
          const res = await uploadFile(uploadFileURL, image,handleProgress);  
          allImages[index] = res.data.downloadURL; 
        } catch(err) {
          allImages[index] = image;  
        } finally {
          processImagesCount++;
          if (processImagesCount === images.length) {
            resolve(allImages);
          }
        }
      });  
    });
    return uploadPromise.then(() => {      
      const successful = allImages.filter(img => typeof img === 'string');
      const failure = allImages.filter(img => typeof img !== 'string');
      if (failure.length > 0) {
        cb(failure);
      }
      return Promise.resolve(successful)  
    })
  }
  return Promise.resolve([]);
}